<template>
  <v-tabs
    v-model="tab"
    background-color="white"
    prev-icon="mdi-chevron-left"
    next-icon="mdi-chevron-right"
  >
    <v-tabs-slider></v-tabs-slider>

    <v-tab v-for="tabItem in tabs" :key="tabItem.key" :href="`#${tabItem.key}`">
      <v-badge
        color="primary"
        :content="$store.get(tabItem.diffGetter)"
        :value="$store.get(tabItem.diffGetter)"
      >
        {{ tabItem.name }}
      </v-badge>
    </v-tab>

    <v-tab-item v-for="tabItem in tabs" :key="tabItem.key" :value="tabItem.key">
      <v-divider />
      <component :is="tabItem.component" />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import TrainDeviationContainer from '@/modules/trainDeviation/components/TrainDeviationContainer'
import DelayContainer from '@/modules/delay/components/DelayContainer'
import CrewContainer from '@/modules/crew/components/CrewContainer'
import TurnaroundContainer from '@/modules/turnaround/components/TurnaroundContainer'
import ReplacementContainer from '@/modules/replacement/components/ReplacementContainer'
import RejectedStopContainer from '@/modules/rejectedStop/components/RejectedStopContainer'
// import YellowVestContainer from '@/modules/yellowVest/components/YellowVestContainer'
import { get } from 'vuex-pathify'

export default {
  name: 'InputTabs',

  data: () => ({
    tab: 'trainDeviation'
  }),

  computed: {
    selectedUUID: get('event/selectedUUID'),
    selectedDistrictId: get('app/selectedDistrictId'),

    tabs() {
      const tabs = [
        {
          name: 'Tåg',
          key: 'trainDeviation',
          diffGetter: 'trainDeviation/diffItemsCountTrainDeviation',
          component: TrainDeviationContainer
        },
        {
          name: 'Förseningar',
          key: 'delay',
          diffGetter: 'delay/diffItemsCount',
          component: DelayContainer
        },
        {
          name: 'Tågvändningar',
          key: 'turnaround',
          diffGetter: 'turnaround/diffItemsCount',
          component: TurnaroundContainer
        },
        {
          name: 'Ersättningstrafik',
          key: 'replacement',
          diffGetter: 'replacement/diffItemsCount',
          component: ReplacementContainer
        },
        {
          name: 'Slopat uppehåll',
          key: 'rejectedStop',
          diffGetter: 'trainDeviation/diffItemsCountRejectedStop',
          component: RejectedStopContainer
        }

        // {
        //   name: 'Gulvästar',
        //   key: 'yellowVest',
        //   component: YellowVestContainer
        // }
      ]

      if (this.selectedDistrictId === 5) {
        tabs.push({
          name: 'Bemanning',
          key: 'crew',
          diffGetter: 'crew/diffItemsCount',
          component: CrewContainer
        })
      }
      return tabs
    }
  }
}
</script>
